/* eslint-disable */
import { useTranslation } from "react-i18next";
import { Box, Divider, Typography } from "@mui/material";
import React, { useEffect } from "react";
import styles from "./AmarantComponent.module.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { listPaymentIntents } from "../../actions/amarantFields";
import { connect } from "react-redux";
import moment from "moment";
import {
  getBaseCurrencyBySwitchDate,
  getDisplayCurrencyOrderBySwitchDate,
  getDualAmountsFromBase,
  formatMoney,
  getCurrencySymbol,
  toNumberOrNull,
} from "../../utils/currency";

// Styles that remove MUI shadows
const overrideMuiStyles = {
  boxShadow: "none !important",
  padding: 0,
  margin: 0,
  elevation: 0,
  border: "none",
};

const columnNames = [
  "amarant:colPaymentType",
  "amarant:colIdentifier",
  "amarant:colStatus",
  "amarant:colPaymentSystem",
  "amarant:colAmount",
  "amarant:colCreatedDate",
  "amarant:colPaymentDate",
];

const statusKeyMap = {
  succeeded: "amarant:stSucceeded",
  failed: "amarant:stFailed",
  processing: "amarant:stProcessing",
  created: "amarant:stCreated",
  paid: "amarant:stPaid",
  requiresAction: "amarant:stRequiresAction",
  requires_payment_method: "amarant:stProcessing",
  requires_confirmation: "amarant:stProcessing",
  requires_action: "amarant:stRequiresAction",
};

const paymentTypeKeyMap = {
  Vignette: "amarant:ptVignette",
  VignetteFine: "amarant:ptVignetteFine",
  Fine: "amarant:ptFine",
  OrderedInsurancePolicy: "amarant:ptOrderedPolicy",
  InspectionAppointment: "amarant:ptInspection",
  AppUser: "amarant:ptSubscription",
  CustomerSupportPayment: "amarant:ptOther",
  MultipleInsurancePolicyInstallments: "amarant:ptPolicyInstallments",
  Appraisal: "amarant:ptAppraisal",
  GeoWash: "amarant:ptGeoWash",
};

const translatePaymentType = (refName, subscriptionType, t) => {
  if (refName === "AppUser" && subscriptionType) {
    return subscriptionType === "yearly"
      ? t("amarant:subscriptionYearly")
      : t("amarant:subscriptionMonthly");
  }
  return paymentTypeKeyMap[refName] ? t(paymentTypeKeyMap[refName]) : refName;
};

const formatDate = (dateString) => {
  if (!dateString || dateString === "-") return "-";
  try {
    const date = moment(dateString);
    return date.isValid() ? date.format("DD.MM.YYYY HH:mm") : "-";
  } catch (e) {
    console.error("Error formatting date:", e);
    return "-";
  }
};

function PaymentIntentsComponent({
  paymentIntents,
  listPaymentIntents,
  customerID,
}) {
  const { t } = useTranslation();
  const [filter, setFilter] = React.useState("");
  const now = new Date();
  const baseCurrency = getBaseCurrencyBySwitchDate(now);
  const displayOrder = getDisplayCurrencyOrderBySwitchDate(now);

  const renderAmount = (amount) => {
    const dual = getDualAmountsFromBase(amount, baseCurrency);
    const primary = displayOrder[0];
    const secondary = displayOrder[1];
    const primaryAmount = dual?.[primary];
    const secondaryAmount = dual?.[secondary];

    if (toNumberOrNull(primaryAmount) === null) return "-";

    return (
      <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.1 }}>
        <b>{`${formatMoney(primaryAmount)} ${getCurrencySymbol(primary)}`}</b>
        {toNumberOrNull(secondaryAmount) !== null && (
          <Typography variant="caption" color="text.secondary">
            {`≈ ${formatMoney(secondaryAmount)} ${getCurrencySymbol(secondary)}`}
          </Typography>
        )}
      </Box>
    );
  };

  useEffect(() => {
    listPaymentIntents({
      customerSupportId: customerID,
    });
  }, []);

  return (
    <>
      <div
        style={{
          height: window.innerWidth < 900 ? "120%" : "75vh",
          width: "100%",
          overflowX: "auto",
          overflowY: "auto",
          ...overrideMuiStyles,
        }}
        className="override-mui-shadow"
      >
        {window.innerWidth < 900 ? (
          <React.Fragment>
            <div
              className={styles["tabs-container"]}
              style={{ padding: "0px" }}
            >
              {paymentIntents.map((payment, i) => {
                return (
                  <div
                    className={styles["row-container"]}
                    style={{
                      marginTop: "5%",
                      display: "block",
                      height: "unset",
                    }}
                    key={i}
                  >
                    <div className={styles["mobile-box"]}>
                      <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {t(columnNames[0])}
                      </p>
                      <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {translatePaymentType(
                          payment?.refName,
                          payment?.subscriptionType,
                          t
                        )}
                      </b>
                    </div>
                    <Divider />
                    <div className={styles["mobile-box"]}>
                      <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {t(columnNames[1])}
                      </p>
                      <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {payment?.refDocument}
                      </b>
                    </div>
                    <Divider />
                    <div className={styles["mobile-box"]}>
                      <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {t(columnNames[2])}
                      </p>
                      <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {statusKeyMap[payment?.status]
                          ? t(statusKeyMap[payment?.status])
                          : payment?.status}
                      </b>
                    </div>
                    <Divider />
                    <div className={styles["mobile-box"]}>
                      <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {t(columnNames[3])}
                      </p>
                      <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {payment?.gateway}
                      </b>
                    </div>
                    <Divider />
                    <div className={styles["mobile-box"]}>
                      <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {t(columnNames[4])}
                      </p>
                      <div style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {renderAmount(payment?.amount)}
                      </div>
                    </div>
                    <Divider />
                    <div className={styles["mobile-box"]}>
                      <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {t(columnNames[5])}
                      </p>
                      <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {formatDate(payment?.createdAt)}
                      </b>
                    </div>
                    <Divider />
                    <div className={styles["mobile-box"]}>
                      <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {t(columnNames[6])}
                      </p>
                      <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                        {formatDate(payment?.paymentDate)}
                      </b>
                    </div>
                    <Divider />
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        ) : (
          <div className={styles["tabs-container"]}>
            <div
              className={styles["columns-container"]}
              style={{ marginTop: "-15px", marginBottom: "1%" }}
            >
              <div className={styles["upper-names"]}>
                {columnNames.map((column, i) => (
                  <div
                    className={`${styles["name-icon"]}`}
                    key={i}
                    style={{
                      width: `${100 / columnNames.length}%`,
                      textAlign: "center",
                      paddingLeft: "2px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (filter === i.toString()) {
                        setFilter(`reverse${i}`);
                      } else {
                        setFilter(i.toString());
                      }
                    }}
                  >
                    <p>{t(column)}</p>
                  </div>
                ))}
              </div>
            </div>

            {paymentIntents && paymentIntents.length > 0 ? (
              paymentIntents.map((payment, i) => (
                <div
                  className={styles["row-container"]}
                  key={i}
                  style={{
                    height: "auto",
                    minHeight: "40px",
                    marginBottom: "1%",
                    boxShadow: "0 0px 10px rgba(5, 5, 5, 0.1)",
                  }}
                >
                  <div
                    className={styles["data"]}
                    style={{
                      width: `${100 / columnNames.length}%`,
                      textAlign: "center",
                    }}
                  >
                    <b>
                      {translatePaymentType(
                        payment?.refName,
                        payment?.subscriptionType,
                        t
                      )}
                    </b>
                  </div>
                  <div
                    className={styles["data"]}
                    style={{
                      width: `${100 / columnNames.length}%`,
                      textAlign: "center",
                    }}
                  >
                    <b>{payment?.refDocument}</b>
                  </div>
                  <div
                    className={styles["data"]}
                    style={{
                      width: `${100 / columnNames.length}%`,
                      textAlign: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor:
                            payment?.status === "succeeded" ||
                            payment?.status === "paid"
                              ? "green"
                              : payment?.status === "failed"
                              ? "red"
                              : "orange",
                          mr: 1,
                        }}
                      />
                      <b>{statusKeyMap[payment?.status]
                          ? t(statusKeyMap[payment?.status])
                          : payment?.status}</b>
                    </Box>
                  </div>
                  <div
                    className={styles["data"]}
                    style={{
                      width: `${100 / columnNames.length}%`,
                      textAlign: "center",
                    }}
                  >
                    <b>{payment?.gateway}</b>
                  </div>
                  <div
                    className={styles["data"]}
                    style={{
                      width: `${100 / columnNames.length}%`,
                      textAlign: "center",
                    }}
                  >
                    {renderAmount(payment?.amount)}
                  </div>
                  <div
                    className={styles["data"]}
                    style={{
                      width: `${100 / columnNames.length}%`,
                      textAlign: "center",
                    }}
                  >
                    <b>{formatDate(payment?.createdAt)}</b>
                  </div>
                  <div
                    className={styles["data"]}
                    style={{
                      width: `${100 / columnNames.length}%`,
                      textAlign: "center",
                    }}
                  >
                    <b>{formatDate(payment?.paymentDate)}</b>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center", padding: "16px" }}>
                <Typography>{t("amarant:noPayments")}</Typography>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  paymentIntents: state.amarantFields.paymentIntents,
});

const mapDispatchToProps = (dispatch) => ({
  listPaymentIntents: (payload) => dispatch(listPaymentIntents(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentIntentsComponent);
